import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MapService } from '../../core/services/map.service';
import { TranslateService } from '@ngx-translate/core';
import {
  AssetHistoryGraphInput,
  AssetMetadataInput,
  FilterInput,
  HierarchyFilterInput,
  KendoGridFilters,
  SurveyRouteFilterInput,
} from '../../../awsAppSync/API';
import { Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import { AuthenticateUserState } from '../../core/store/authenticate-user.state';
import { Level3State } from '../../core/store/filter-level3.state';
import { SegmentTypeState } from '../../core/store/filter-segmenttype.state';
import { SegmentState } from '../../core/store/filter-segments';
import { SurveyRouteState } from '../../core/store/filter-serveyrotes';
import { AssetTypeState } from '../../core/store/filter-assettype';
import {
  ACPOI,
  ANODE,
  BOND,
  CASING,
  COMPLIANT_AH,
  CTS,
  DEFAULT,
  DELINQUENT_AH,
  EMPTY_STRING,
  ER_PROBE,
  ESN,
  EXCEPTION_AH,
  ISOLATIONJOINT,
  ND,
  RD,
  RECTIFIER,
  REDIRECT_ASSET_HISTORY,
  REDIRECT_INSPECTION,
  SHORT,
  ST,
  TEST_POINT,
  TH,
  ZERO,
} from '../../shared/constants';
import { AssetSetupService } from '../../core/services/asset-setup.service';
import { HeirarchyFilterServiceService } from '../../shared/service/heirarchy-filter-service/heirarchy-filter-service.service';
import { Level1LevelNameState } from '../../core/store/filter-level1Name.state';
import { Level2LevelNameState } from '../../core/store/filter-level2Name.state';
import { Level3LevelNameState } from '../../core/store/filter-level3Name.state';
import { AbstractControl, FormBuilder, FormGroup } from '@angular/forms';
import { AssetHistoryService } from '../../core/services/asset-history.service';
import { AssetHistoryChartComponent } from '../asset-history/asset-history-chart/asset-history-chart.component';
import { InspectionService } from '../../core/services/inspection.service';
import { ExceptionService } from '../exception/service/exception.service';
import { MeasurementTypeBasedOnAssetType } from '../../shared/enums';
import { SelectedcompanyConfigData } from '../../core/store/company-config.state';
import { HelperService } from '../../shared/service/helper/helper.service';
declare let google: any;
@Component({
  selector: 'app-maps',
  templateUrl: './maps.component.html',
  styleUrls: ['./maps.component.css'],
})
export class MapsComponent implements OnInit, OnDestroy {
  dateRangeForm: FormGroup;
  startDate: Date | null = new Date();
  endDate: Date | null = new Date();
  assetHistoryStartDate: string | null = EMPTY_STRING;
  assetHistoryEndDate: string | null = EMPTY_STRING;
  assetMetadataInput: AssetMetadataInput = {
    primaryCompany: EMPTY_STRING,
    level1: EMPTY_STRING,
    level2: EMPTY_STRING,
    level3: EMPTY_STRING,
    assetId: EMPTY_STRING,
  };
  assetHistoryGraphInput: AssetHistoryGraphInput = {
    primaryCompany: EMPTY_STRING,
    level1: EMPTY_STRING,
    level2: EMPTY_STRING,
    level3: EMPTY_STRING,
    assetId: EMPTY_STRING,
    startDate: EMPTY_STRING,
    endDate: EMPTY_STRING,
    measurementTypes: [],
  };
  currentCompanyConfig$: Observable<any | null>;
  currentCompanyConfig: any | null;
  currentAssetTechResponsible: any | null;
  constructor(
    public dialog: MatDialog,
    private router: Router,
    private mapService: MapService,
    private translate: TranslateService,
    private assetSetupService: AssetSetupService,
    private assetHistoryService: AssetHistoryService,
    private store: Store,
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    private hierarchyFilter: HeirarchyFilterServiceService,
    public inspectionService: InspectionService,
    public assetHistoryservice: AssetHistoryService,
    public exceptionService: ExceptionService,
    private helperService: HelperService,
  ) {
    const currentYear = new Date().getFullYear();
    this.startDate = new Date(currentYear - 3, 0, 1); // January 1st
    this.endDate = new Date(currentYear, 11, 31); // December 31st
    this.dateRangeForm = this.fb.group(
      {
        startDate: [this.startDate],
        endDate: [this.endDate],
      },
      { validator: this.dateRangeValidator },
    );
    this.storePrimaryCompanyID$ = this.store.select(
      AuthenticateUserState.getSyrcPrimaryCompanyId,
    );
    this.storeSelectedLevel3$ = this.store.select(
      Level3State.getSelectedLevel3Name,
    );
    this.storeSegmentTypeSet$ = this.store.select(
      SegmentTypeState.getSelectedSegmentType,
    );
    this.storeSelectedSegments$ = this.store.select(
      SegmentState.getSelectedSegmentIds,
    );
    this.storeSelectedSurveyRoute$ = this.store.select(
      SurveyRouteState.getSelectedSurveyRouteIds,
    );
    this.storeSelectedAssetType$ = this.store.select(
      AssetTypeState.getSelectedAssetTypeIds,
    );
    this.storeLevel1Name$ = this.store.select(
      Level1LevelNameState.getLevel1LevelNameId,
    );
    this.storeLevel2Name$ = this.store.select(
      Level2LevelNameState.getLevel2LevelNameId,
    );
    this.storeLevel3Name$ = this.store.select(
      Level3LevelNameState.getLevel3LevelNameId,
    );
    this.currentCompanyConfig$ = this.store.select(
      SelectedcompanyConfigData.getcompanyConfigData,
    );
  }
  allAssetsData: any[] = [];
  assetData: any[] = [];
  searchPlaceholder = 'Search assets on map';
  isLoading = false;
  includeLegendsMarkers = true;
  filterModel: FilterInput = {};
  kendoGridFilters: KendoGridFilters = {};
  storePrimaryCompanyID$: Observable<string | null>;
  selectedprimaryComapnyId: string | null = '';
  storeSelectedLevel3$: Observable<string[]>;
  selectedLevel3: string[] = [];
  storeSegmentTypeSet$: Observable<string[]>;
  selectedSegmentType: string[] = [];
  storeSelectedSegments$: Observable<string[]>;
  selectedSegments: string[] = [];
  storeSelectedSurveyRoute$: Observable<string[]>;
  selectedSurveyRoute: string[] = [];
  storeSelectedAssetType$: Observable<string[]>;
  selectedAssetType: string[] = [];
  hierarchyFilterInput: HierarchyFilterInput[] = [];
  surveyRouteFilterInput: SurveyRouteFilterInput[] = [];
  currentPage = 0;
  pageSize = 1000;
  public searchText = EMPTY_STRING;
  filterTrayOpen = false;
  @ViewChild('map', { static: true }) mapElementRef!: ElementRef;
  @ViewChild(AssetHistoryChartComponent) assetChart?: AssetHistoryChartComponent;
  center: { lat: number; lng: number } | undefined; // No default center
  map: any;
  showGraph = false;
  storeLevel1Name$: Observable<string | null>;
  storeLevel2Name$: Observable<string | null>;
  storeLevel3Name$: Observable<string | null>;
  level1Name = '';
  level2Name = '';
  level3Name = '';
  primaryCompany: string | null = EMPTY_STRING;
  level1: string | null = EMPTY_STRING;
  level2: string | null = EMPTY_STRING;
  level3: string | null = EMPTY_STRING;
  currentLevel1: string | null | undefined = EMPTY_STRING;
  currentLevel2: string | null | undefined = EMPTY_STRING;
  currentLevel3: string | null | undefined = EMPTY_STRING;
  measurementTypeArray: string[] = [];
  measurementTypeArrayWithSegment: string[] = [];
  measurementCriteriaInputs: any[] = [];
  private graphRequestSeq = 0;
  private infoCardSeq = 0;
  private chartRefreshTimer?: ReturnType<typeof setTimeout>;

  query = '';
  filteredResults: any[] = [];
  selectedAsset: any;
  selectedAssetId = EMPTY_STRING;
  infoCardStyles: any = { display: 'none' }; // Initially hidden
  isFullScreen = false;

  infowindow!: google.maps.InfoWindow;

  markerMap = new Map();
  selectedAssetData: any;

  enableMapSearch = false;
  isLevel3Selected = false;
  spatialReferenceLabel = EMPTY_STRING;

  ngOnInit(): void {
    this.selectedAssetData = this.assetHistoryService.selectedRowData;
    this.storePrimaryCompanyID$.subscribe((id) => {
      this.selectedprimaryComapnyId = '';
      this.selectedprimaryComapnyId = id;
    });

    this.storeSelectedLevel3$.subscribe((level3name) => {
      this.selectedLevel3 = level3name;
      this.hierarchyFilterInput = [];
      this.isLevel3Selected = false;
      this.enableMapSearch = false;
      if (this.selectedprimaryComapnyId && this.selectedLevel3.length > 0) {
        this.fetchLevel3Values(this.selectedprimaryComapnyId);
        this.isLevel3Selected = true;
      }
    });

    this.storeSegmentTypeSet$.subscribe((segmentType) => {
      this.selectedSegmentType = [];
      this.selectedSegmentType = segmentType;
    });

    this.currentCompanyConfig$.subscribe((data) => {
      this.currentCompanyConfig = data;
    });

    this.storeSelectedSegments$.subscribe((segment) => {
      this.selectedSegments = [];
      this.selectedSegments = segment;
    });

    this.storeSelectedSurveyRoute$.subscribe((Surveyroute) => {
      this.surveyRouteFilterInput = [];
      this.selectedSurveyRoute = Surveyroute;
      if (
        this.selectedSurveyRoute.length > 0 &&
        this.selectedprimaryComapnyId
      ) {
        this.fetchSurveyRouteValues(this.selectedprimaryComapnyId);
      }
    });

    this.storeSelectedAssetType$.subscribe((assettype) => {
      this.selectedAssetType = [];
      this.selectedAssetType = assettype;
    });

    this.storeLevel1Name$.subscribe((level1name) => {
      this.level1Name = level1name!;
    });
    this.storeLevel2Name$.subscribe((level2name) => {
      this.level2Name = level2name!;
    });
    this.storeLevel3Name$.subscribe((level3name) => {
      this.level3Name = level3name!;
    });

    this.dateRangeForm.get('startDate')?.valueChanges.subscribe((value) => {
      if (!this.dateRangeForm.errors?.['dateRangeInvalid']) {
        this.startDate = value;
        this.assetHistoryStartDate = this.formatToISO(this.startDate);
        this.creategraph();
      }
    });

    this.dateRangeForm.get('endDate')?.valueChanges.subscribe((value) => {
      if (!this.dateRangeForm.errors?.['dateRangeInvalid']) {
        this.endDate = value;
        this.assetHistoryEndDate = this.formatToISO(this.endDate);
        this.creategraph();
      }
    });

    this.assetHistoryStartDate = this.formatToISO(this.startDate);
    this.assetHistoryEndDate = this.formatToISO(this.endDate);
    this.loadAssetData();
    if (this.isLevel3Selected) {
      this.enableMapSearch = true;
    }
    this.spatialReferenceLabel = this.currentCompanyConfig.spatialReference1
      ? this.currentCompanyConfig.spatialReference1 +
        ' ' +
        this.currentCompanyConfig.spatialReference1Unit
      : '';
  }

  formatToISO(date: Date | null): string | null {
    return date ? new Date(date).toISOString() : null;
  }

  dateRangeValidator(
    formGroup: AbstractControl,
  ): Record<string, boolean> | null {
    const startDate = formGroup.get('startDate')?.value;
    const endDate = formGroup.get('endDate')?.value;

    if (startDate && endDate && startDate > endDate) {
      return { dateRangeInvalid: true };
    }
    return null;
  }

  loadAssetPlottingData() {
    this.mapService.assetData = this.assetData;
    this.allAssetsData = this.mapService.getData();
  }

  mapClearFilterButtonClick() {
    this.loadAssetData();
  }

  async loadAssetData(): Promise<void> {
    try {
      this.isLoading = true;
      await this.fetchLevel3Values(this.selectedprimaryComapnyId!);
      this.updateFilterModel();
      const response = await this.assetSetupService.getAssets(this.filterModel);
      if (response) {
        const selected = this.exceptionService.selectedRowData;
        if (selected != null) {
          const filtered = response.assets.filter(
            (item: any) => item.pk === selected.pk && item.id === selected.id,
          );
          this.assetData = filtered;
          this.exceptionService.selectedRowData = null;
        } else {
          this.assetData = response.assets;
        }
        this.loadAssetPlottingData();
      }
      this.center = this.mapService.getMapCenter();
      this.loadMap();
      this.isLoading = false;
    } catch (error) {
      this.isLoading = false;
      console.log('Error: ', error);
    }
  }

  filterSearchButtonClicked(): void {
    if (this.isLevel3Selected) {
      this.enableMapSearch = true;
    }
    this.loadAssetData();
    this.filterTrayOpen = true;
    this.closeInfoCard();
  }

  updateFilterModel() {
    this.filterModel = {
      primaryCompany: this.selectedprimaryComapnyId,
      level4: this.selectedSegments,
      assetTypes: this.selectedAssetType,
      segmentTypes: this.selectedSegmentType,
      surveyRouteFilterInputs: this.surveyRouteFilterInput,
      hierarchyFilterInputs: this.hierarchyFilterInput,
      pageSize: this.pageSize,
      pageNumber: this.currentPage,
      searchText: this.searchText,
      gridFilters: this.kendoGridFilters,
    };
  }

  async fetchLevel3Values(primaryCompanyId: string) {
    const allLevel3Values: HierarchyFilterInput[] = [];
    const level3Values =
      await this.hierarchyFilter.getAllLevel3ValueByPrimaryCompany(
        primaryCompanyId,
      );
    if (level3Values?.items) {
      level3Values.items.forEach((item) => {
        if (item) {
          if (this.selectedLevel3.includes(item.id))
            allLevel3Values.push({
              level1: item.level1ValueId || '',
              level2: item.level2ValueId || '',
              level3: item.id || '',
            });
        }
      });
    }
    this.hierarchyFilterInput = allLevel3Values;
  }

  async fetchSurveyRouteValues(primaryCompanyId: string) {
    const allSurveyRouteFilterValues: SurveyRouteFilterInput[] = [];
    const surveyRouteValues =
      await this.hierarchyFilter.getAllSurveyRouteBySubFilterInput({
        primaryCompanyId: primaryCompanyId,
      });
    if (surveyRouteValues?.items) {
      surveyRouteValues.items.forEach((item) => {
        if (item) {
          if (this.selectedSurveyRoute.includes(item.id)) {
            item.RouteAssociateAssetList?.forEach((level) => {
              level?.level3ValueIdList?.forEach((l3) => {
                allSurveyRouteFilterValues.push({
                  level1: level?.level1ValueId,
                  level2: level?.level2ValueId,
                  level3: l3,
                  assetId: level.assetId,
                });
              });
            });
          }
        }
      });
    }
    this.surveyRouteFilterInput = allSurveyRouteFilterValues;
  }

  async loadMap(): Promise<void> {
    // Import required libraries once
    const mapsLib = (await google.maps.importLibrary(
      'maps',
    )) as google.maps.MapsLibrary;
    const coreLib = (await google.maps.importLibrary(
      'core',
    )) as google.maps.CoreLibrary;
    await google.maps.importLibrary('marker'); // Needed for Marker in plotMarkers()

    const mapEl = this.mapElementRef.nativeElement;

    // Create Map
    this.map = new mapsLib.Map(mapEl, {
      center: this.center,
      zoom: 6,
      minZoom: 4,
      mapId: '4504f8b37365c3d01',
    });

    // Create InfoWindow safely after libraries load
    this.infowindow = new mapsLib.InfoWindow({
      pixelOffset: new coreLib.Size(500, -300),
    });

    // Plot markers
    this.plotMarkers();
  }

  openExportMapModal(): void {
    this.mapService.initialize(this.mapElementRef.nativeElement, this.map);
    this.mapService.openExportMapModal();
    this.collapseFilterTray();
  }

  ngOnDestroy(): void {
    // SYRC-6964: invalidate every tap/graph request still in flight so a response that lands
    // after the Map view is gone can't write the shared AssetHistoryService state, re-stamp the
    // info card or redraw a destroyed chart (e.g. into the Asset History page's #chart-container).
    this.graphRequestSeq++;
    this.infoCardSeq++;
    clearTimeout(this.chartRefreshTimer);
    if (this.map) {
      google.maps.event.clearInstanceListeners(this.map);
    }
    this.markerMap.forEach((marker) =>
      google.maps.event.clearInstanceListeners(marker),
    );
  }

  handleSearchInput(value: string): void {
    this.query = value;
    this.filteredResults = this.allAssetsData
      .filter((asset) =>
        asset.assetName.toLowerCase().includes(this.query.toLowerCase()),
      )
      .map((asset) => asset.assetName); // Map to array of asset names
  }

  onSelectAsset(assetName: string): void {
    this.query = assetName;
    this.filteredResults = [];
    const asset = this.allAssetsData.find((a) => a.assetName === assetName);
    if (asset) {
      this.focusOnAsset(asset);
    }
  }

  selectResult(assetName: string): void {
    this.query = assetName;
    this.filteredResults = [];
    const asset = this.allAssetsData.find((a) => a.assetName === assetName);
    if (asset) {
      this.map.setZoom(12);
      this.focusOnAsset(asset);
    }
  }

  private focusOnAsset(asset: any): void {
    // Same path as a marker tap: loads this asset's details and graph data, redraws (or clears)
    // the chart, then builds the info card. Setting selectedAsset directly here left the previous
    // asset's graph and legend on screen.
    this.showInfoCard(asset);

    const latLng = new google.maps.LatLng(
      parseFloat(asset.latitude),
      parseFloat(asset.longitude),
    );
    this.map.setCenter(latLng);
    this.map.setZoom(15); // Adjust zoom level to focus on asset

    // Clear bounce animation for all markers
    this.markerMap.forEach((marker) => {
      marker.setAnimation(null);
    });

    // Get the selected marker
    const markerId = parseInt(asset.assetId);
    const marker = this.markerMap.get(markerId);

    if (marker) {
      marker.setAnimation(google.maps.Animation.BOUNCE);
      setTimeout(() => marker.setAnimation(null), 1500); // Stop bouncing after 1.5 seconds
    }
  }

  plotMarkers(): void {
    this.allAssetsData.forEach((data) => {
      const latLng = new google.maps.LatLng(+data.latitude, +data.longitude);
      const markerText = this.getMarkerText(data.assetType);
      const fillColor = this.getColorByStatus(data.status);

      const overlay = new google.maps.OverlayView();

      overlay.onAdd = () => {
        const div = document.createElement('div');
        div.className = 'custom-svg-marker';
        div.title = `${data.assetName}\nLat: ${data.latitude}, Lng: ${data.longitude}`;

        const createSvgMarker = (label: string, color: string) => {
          return `
           <svg xmlns="http://www.w3.org/2000/svg" width="28" height="42" viewBox="0 0 32 48">
            <!-- White border -->
            <path d="M16,0 C24.8366,0 32,7.16344 32,16 C32,27.25 16,48 16,48 C16,48 0,27.25 0,16 C0,7.16344 7.16344,0 16,0 Z"
                  fill="${color}" stroke="#FFFFFF" stroke-width="2"/>
            
            <!-- Optional soft shadow -->
            <path d="M16,0 C24.8366,0 32,7.16344 32,16 C32,27.25 16,48 16,48 C16,48 0,27.25 0,16 C0,7.16344 7.16344,0 16,0 Z"
                  fill="none" stroke="#00000033" stroke-width="1"/>

            <!-- Marker label -->
            <text x="16" y="21" text-anchor="middle" font-size="16" font-weight="bold" fill="#fff" font-family="Arial, sans-serif" dy=".3em">${label}</text>
          </svg>`;
        };

        div.innerHTML = createSvgMarker(markerText, fillColor);

        Object.assign(div.style, {
          position: 'absolute',
          transform: 'translate(-50%, -100%)',
          cursor: 'pointer',
          zIndex: '10',
        });

        div.addEventListener('click', () => {
          this.showInfoCard(data);
          this.closeInfoWindow();

          if (this.isFullScreen) {
            const dummyMarker = new google.maps.Marker({
              position: latLng,
              map: this.map,
            });
            this.infowindow.open({ anchor: dummyMarker, map: this.map });
            this.infowindow.setContent(this.generateInfoWindowContent());
          }
        });

        overlay.getPanes()?.overlayMouseTarget?.appendChild(div);
        overlay.draw = () => {
          const projection = overlay.getProjection();
          const position = projection.fromLatLngToDivPixel(latLng);
          if (position) {
            div.style.left = `${position.x}px`;
            div.style.top = `${position.y}px`;
          }
        };
      };

      overlay.setMap(this.map);
    });
  }

  getMarkerText(assetType: string): string {
    let markertext = 'M';
    if (assetType == RECTIFIER) {
      markertext = 'R';
    } else if (assetType == TEST_POINT) {
      markertext = 'T';
    } else if (assetType == BOND) {
      markertext = 'B';
    } else if (assetType == ANODE) {
      markertext = 'A';
    } else if (assetType == CASING) {
      markertext = 'CS';
    } else if (assetType == CTS) {
      markertext = 'CP';
    } else if (assetType == ER_PROBE) {
      markertext = 'ER';
    } else if (assetType == ISOLATIONJOINT) {
      markertext = 'IJ';
    } else {
      const firstLetter = assetType.charAt(0).toUpperCase();
      markertext = firstLetter;
    }
    return markertext;
  }

  getColorByStatus(assetstatus: string): string {
    let fillColor = '#22C55E';
    if (assetstatus == COMPLIANT_AH) {
      fillColor = '#22C55E';
    } else if (assetstatus == EXCEPTION_AH) {
      fillColor = '#E5AB09';
    } else if (assetstatus == DELINQUENT_AH) {
      fillColor = '#E77A3C';
    }
    return fillColor;
  }

  private async showInfoCard(asset: any): Promise<void> {
    // SYRC-6964: order taps with their own counter (not graphRequestSeq, which the date pickers
    // also bump) so an earlier tap that resolves late - even of the same asset - can't re-stamp
    // the info card or re-init the chart.
    const tap = ++this.infoCardSeq;
    this.selectedAssetId = asset.id;
    this.level1 = asset.level1ValueId;
    this.level2 = asset.level2ValueId;
    this.level3 = asset.level3ValueId;
    await this.creategraph();
    if (tap !== this.infoCardSeq) {
      return;
    }
    let spatialRef = asset.spatialReference1;
    if (this.currentCompanyConfig.spatialReference1DataType === ESN) {
      spatialRef = this.helperService.toESN(
        asset.spatialReference1 ?? ZERO,
        this.currentCompanyConfig.spatialReference1Unit,
      );
    }
    this.selectedAsset = {
      id: asset.id,
      assetName: asset.assetName,
      assetType: asset.assetType,
      station: '10+001.4',
      techResponsible: this.currentAssetTechResponsible,
      spatialReference1: spatialRef,
      locationDescription: asset.locationDescription,
      status: asset.status,
      inspectionDate: this.formatDate(asset.targetDate),
      assetDelinquencyDate: this.formatDate(asset.assetDelinquencyDate),
    };
    // Asset History needs the raw asset (pk, hierarchy ids), not the formatted card. Always take the
    // latest selection: keeping the first one sent the user to a previously selected asset.
    this.selectedAssetData = asset;
    this.infoCardStyles = {
      display: 'block',
      position: 'absolute',
      top: this.showHierarchicalFilter ? '103px' : '10px',
      right: '10px',
      width: '300px', // Adjust width if needed
      zIndex: 900,
    };
  }

  // SYRC-6964: the chart mounts once (with showGraph) and stays mounted; redraw it from the latest
  // data. Re-creating it on every tap through an *ngIf toggle and relying on its 5 s deferred first
  // render was timing-dependent and left a stale or empty graph. Deferred one tick so a chart that
  // is appearing for the first time (showGraph just turned true) exists by then.
  refreshChart(): void {
    clearTimeout(this.chartRefreshTimer);
    this.chartRefreshTimer = setTimeout(() => this.assetChart?.refresh(), 0);
  }

  async creategraph() {
    this.isLoading = true;
    this.mapAssetHistoryMetaDataInput();
    await this.getAssetDetailsById();
    this.showGraph = true;
  }

  mapAssetHistoryMetaDataInput() {
    this.assetMetadataInput = {
      primaryCompany: this.selectedprimaryComapnyId!,
      level1: this.level1!,
      level2: this.level2!,
      level3: this.level3!,
      assetId: this.selectedAssetId!,
    };
  }

  mapAssetHistoryGraphInput() {
    this.assetHistoryGraphInput = {
      primaryCompany: this.selectedprimaryComapnyId!,
      level1: this.currentLevel1!,
      level2: this.currentLevel2!,
      level3: this.currentLevel3!,
      assetId: this.selectedAssetId!,
      startDate: this.assetHistoryStartDate!,
      endDate: this.assetHistoryEndDate!,
      measurementTypes: this.measurementTypeArray,
    };
  }

  async getAssetDetailsById() {
    // SYRC-6964: tag this request so a slower response for a previously tapped asset can't
    // overwrite the graph data of the asset the user selected last.
    const requestSeq = ++this.graphRequestSeq;
    this.isLoading = true;
    this.measurementCriteriaInputs = [];
    this.measurementTypeArray = [];
    this.measurementTypeArrayWithSegment = [];
    const response = await this.assetHistoryService.getAssetDetailsById(
      this.assetMetadataInput,
    );
    if (requestSeq !== this.graphRequestSeq) {
      return;
    }
    // Only patch the card if it belongs to the requested asset: right after a new tap it still
    // shows the previous asset until showInfoCard() rebuilds it.
    if (
      response?.getAssetDetailsById?.status &&
      this.selectedAsset?.id === this.selectedAssetId
    ) {
      this.selectedAsset.status = response.getAssetDetailsById.status;
    }
    // this.currentAssetTechResponsible =
    //   response?.getAssetDetailsById?.techResponsible || [];
    // Resolve the graph query's hierarchy for THIS asset even when the details call failed or the
    // asset has no measurement criteria; otherwise the previous asset's levels were reused.
    this.currentLevel1 = response?.getAssetDetailsById?.level1ValueId ?? this.level1;
    this.currentLevel2 = response?.getAssetDetailsById?.level2ValueId ?? this.level2;
    this.currentLevel3 = response?.getAssetDetailsById?.level3ValueId ?? this.level3;
    if (response && response.getAssetDetailsById?.measurementCriteria) {
      const measurementCriteriaArray =
        response.getAssetDetailsById?.measurementCriteria.map((item) => ({
          measurementSource: item?.measurementSource || EMPTY_STRING,
          measurementType: item?.measurementType || EMPTY_STRING,
          measurementOperator: item?.measurementOperator || EMPTY_STRING,
          criteria: item?.criteria || EMPTY_STRING,
          criteria1: EMPTY_STRING,
          criteria2: EMPTY_STRING,
          segment: item?.level4Value || EMPTY_STRING,
          segmentRelation: item?.level4Relation || EMPTY_STRING,
          compliance: item?.compliance || false,
          unit: item?.unit || EMPTY_STRING,
          exceptionLogic: item?.exceptionLogic || EMPTY_STRING,
          viewInMainGrid: item?.viewInMainGrid || false,
          annualInspection: item?.annualInspection || false,
          periodicInspection: item?.periodicInspection || false,
          supplementalInspection: item?.supplementalInspection || false,
        })) || [];
      this.assetHistoryService.effectiveDates =
        response.getAssetDetailsById.effectiveDates || [];
      this.measurementCriteriaInputs.push(...measurementCriteriaArray);
      this.measurementTypeArray =
        response.getAssetDetailsById?.measurementCriteria.map(
          (item) => item?.measurementType || EMPTY_STRING,
        );
      this.measurementTypeArrayWithSegment =
        response.getAssetDetailsById?.measurementCriteria
          .map((item) => {
            const measurementType = (
              item?.measurementType || EMPTY_STRING
            ).trim();
            const measurementSource = item?.measurementSource || EMPTY_STRING;

            if (
              MeasurementTypeBasedOnAssetType[ACPOI] === measurementType // Check for AssetType ACPOI Specifically
            ) {
              return null;
            }

            return `${measurementSource} - ${measurementType}`.trim();
          })
          .filter((val): val is string => val !== null);
    }
    this.assetHistoryService.measurementTypes = this.measurementTypeArray;
    this.assetHistoryService.measurementTypeArray =
      this.measurementTypeArrayWithSegment;
    this.mapAssetHistoryGraphInput();
    await this.loadAssetGraphData(requestSeq);
  }

  // requestSeq is required: defaulting it to the live counter would silently bypass the guard.
  async loadAssetGraphData(requestSeq: number) {
    const response = await this.assetHistoryService.getAssetHistoryGraph(
      this.assetHistoryGraphInput,
    );
    if (requestSeq !== this.graphRequestSeq) {
      return;
    }
    // A failed graph query resolves to null: still clear the loader (it used to stay up forever)
    // and hand the chart an empty series rather than undefined.
    this.assetHistoryService.graphData =
      response?.getAssetHistoryGraphData?.items ?? [];
    this.isLoading = false;
    // The data is current for the latest tap/date change: redraw the chart from it now.
    this.refreshChart();
  }

  addFullScreenListeners(): void {
    document.addEventListener('fullscreenchange', this.handleFullScreenChange);
    document.addEventListener(
      'webkitfullscreenchange',
      this.handleFullScreenChange,
    );
    document.addEventListener(
      'mozfullscreenchange',
      this.handleFullScreenChange,
    );
    document.addEventListener(
      'MSFullscreenChange',
      this.handleFullScreenChange,
    );
  }

  handleFullScreenChange = () => {
    this.isFullScreen = !!document.fullscreenElement;
    if (!this.isFullScreen) {
      this.closeInfoWindow();
    }
  };

  generateInfoWindowContent(): string {
    if (!this.selectedAsset) return '';

    const assetNameLabel = this.translate.instant('MAP_INFO_CARD.ASSET_NAME');
    const assetTypeLabel = this.translate.instant('MAP_INFO_CARD.ASSET_TYPE');
    const stationLabel = this.translate.instant('MAP_INFO_CARD.STATION');
    const techResponsibleLabel = this.translate.instant(
      'MAP_INFO_CARD.TECH_RESPONSIBLE',
    );
    const complianceStatusLabel = this.translate.instant(
      'MAP_INFO_CARD.COMPLIANCE_STATUS',
    );
    // const complianceMeasurementLabel = this.translate.instant(
    //   'MAP_INFO_CARD.COMPLIANCE_MEASUREMENT',
    // );
    const inspectionDateLabel = this.translate.instant(
      'MAP_INFO_CARD.INSPECTION_DATE',
    );
    const delinquencyDateLabel = this.translate.instant(
      'MAP_INFO_CARD.DELINQUENCY_DATE',
    );

    return `
      <div class="info-card" style="position: relative; width: 250px; padding-top: 0;">
        <div class="info-card-header" style="text-align: center;">
          <h5>${this.translate.instant('MAP_INFO_CARD.ASSET_INFO_CARD')}</h5>
        </div>
        <div class="info-card-content" style="margin-top: 10px;">
          <p><strong>${assetNameLabel}:</strong> ${this.selectedAsset.assetName}</p>
          <p><strong>${assetTypeLabel}:</strong> ${this.selectedAsset.assetType}</p>
          <p><strong>${stationLabel}:</strong> ${this.selectedAsset.station}</p>
          <p><strong>${techResponsibleLabel}:</strong> ${this.selectedAsset.technician}</p>
          <p><strong>${complianceStatusLabel}:</strong> ${this.selectedAsset.status}</p>
          <p><strong>${inspectionDateLabel}:</strong> ${this.selectedAsset.inspectionDate}</p>
          <p><strong>${delinquencyDateLabel}:</strong> ${this.selectedAsset.assetDelinquencyDate}</p>
        </div>
      </div>
    `;
  }

  closeInfoWindow() {
    if (this.infowindow) {
      this.infowindow.close();
    }
  }

  formatDate(date: Date): string {
    if (!date) return '';

    const day = date.getDate();
    const month = date.toLocaleString(DEFAULT, { month: SHORT });
    const year = date.getFullYear();

    const daySuffix = this.getDaySuffix(day);

    return `${day}${daySuffix} ${month}, ${year}`;
  }

  getDaySuffix(day: number): string {
    if (day > 3 && day < 21) return TH;
    switch (day % 10) {
      case 1:
        return ST;
      case 2:
        return ND;
      case 3:
        return RD;
      default:
        return TH;
    }
  }

  closeInfoCard(): void {
    this.selectedAsset = null;
    this.infoCardStyles = { display: 'none' };
  }

  public dropdownData: any[] = [
    { text: 'Inspection', value: 1 },
    { text: 'Asset History', value: 2 },
  ];

  dropdownVisible = false;

  toggleDropdown() {
    this.dropdownVisible = !this.dropdownVisible;
  }

  closePopup() {
    this.dropdownVisible = false;
  }

  openUrl(url: string) {
    if (url === REDIRECT_INSPECTION) {
      this.inspectionService.selectedRowData = this.selectedAsset;
    }
    if (url === REDIRECT_ASSET_HISTORY) {
      this.assetHistoryservice.selectedRowData =
        this.selectedAssetData ?? this.selectedAsset;
    }
    this.router.navigate([url]);
    this.closePopup(); // Close the popup after navigation
  }

  // Ensure clicking outside the popup closes it
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (
      !target.closest('.info-card-header') &&
      !target.closest('.popup-menu')
    ) {
      this.closePopup();
    }
  }

  height = 800; // initial height
  showHierarchicalFilter = false;
  showFilterBtn = true;
  toggleFilterTray() {
    this.filterTrayOpen = true;
    this.showHierarchicalFilter = !this.showHierarchicalFilter;
    this.showFilterBtn = !this.showFilterBtn;
    if (this.showHierarchicalFilter) {
      this.height = 830;
    } else {
      this.height = 800;
    }

    if (this.selectedAsset) {
      this.infoCardStyles = {
        display: 'block',
        position: 'absolute',
        top: this.showHierarchicalFilter ? '103px' : '10px',
        right: '10px',
        width: '300px', // Adjust width if needed
        zIndex: 1000,
      };
    }
  }
  collapseFilterTray() {
    this.toggleFilterTray();
    this.filterTrayOpen = false;
  }
}
